// extracted by mini-css-extract-plugin
export default {"hideArrows":"RkVSVq5HL9FWYPqnMfBj","placeHolderShimmer":"M52sI9acMPTbFJrshMr8"};